import { Head } from '@inertiajs/react';
import { Button } from '@/components/ui/button';

const Scapper = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Head title="scapperemovia" />
      <main className="relative min-h-screen overflow-hidden px-6 py-10">
        <div className="absolute inset-0 bg-linear-to-tr from-muted/40 via-background to-background" aria-hidden="true" />
        <div
          className="absolute left-[5%] top-[10%] h-96 w-96 rounded-full bg-primary/25 blur-3xl"
          aria-hidden="true"
        />
        <div className="relative mx-auto flex min-h-screen max-w-3xl flex-col items-center justify-center gap-6 text-center">
          <h1>scapperemovia</h1>
          <p className="text-muted-foreground">Si scappa dalle complicazioni, non dalla cura.</p>
          <div className="scapper-card w-full max-w-md rounded-2xl border border-border bg-background/80 p-6 text-center shadow-sm">
            <p className="text-muted-foreground">Uscita trovata. Non serve perdersi.</p>
          </div>
          <Button asChild>
            <a href="https://www.emovia.com">Scopri Emovia</a>
          </Button>
          <div className="rounded-full border border-border px-4 py-1">
            <p className="text-muted-foreground">Una porta sola, quella giusta</p>
          </div>
        </div>
      </main>
      <style>{`
        .scapper-card {
          animation: scapper-glow 3s ease-in-out infinite;
        }
        @keyframes scapper-glow {
          0% { box-shadow: 0 0 0 0 hsl(var(--border)); }
          50% { box-shadow: 0 0 24px 0 hsl(var(--primary) / 0.25); }
          100% { box-shadow: 0 0 0 0 hsl(var(--border)); }
        }
        @media (prefers-reduced-motion: reduce) {
          .scapper-card { animation: none; }
        }
      `}</style>
    </div>
  );
};

export default Scapper;
